import type { IBackboneHotelOffer } from '@ve/types/backboneModels/Domain/ObjectValue';
import type { ProviderOffer } from '../model/types';

const buildProviderOffers = (hotelOffers: IBackboneHotelOffer[]): ProviderOffer[] =>
  hotelOffers.map((hotelOffer) => {
    const operator = hotelOffer.get('operator');
    return {
      offerId: hotelOffer.get('id') ?? '',
      operatorId: operator?.id ?? 0,
      operatorName: operator?.name ?? '',
      price: hotelOffer.get('price') ?? 0,
      bookingUrl: hotelOffer.get('bookingUrl'),
    };
  });

export default buildProviderOffers;
